import { Alert, Snackbar } from '@mui/material';
import { useSelector } from 'react-redux';
import { updateSnackbar } from '../redux/appSlice';
import { useAppDispatch, RootState } from '../redux/store';

export default function SnackbarProvider({ children }: any) {
	const dispatch = useAppDispatch();
	const { snackbar } = useSelector((state: RootState) => state.app);

	return (
		<>
			<Snackbar
				open={snackbar?.snackbarActive}
				autoHideDuration={6000}
				onClose={() => {
					dispatch(updateSnackbar({ snackbarActive: false, snackbarMessage: '' }));
				}}
				anchorOrigin={snackbar?.snackbarPosition ?? { vertical: 'bottom', horizontal: 'center' }}
				action={'Close'}
			/>
			{snackbar?.snackbarMessage && snackbar?.snackbarActive && (
				<Alert
					onClose={() => {
						dispatch(updateSnackbar({ snackbarActive: false, snackbarMessage: '' }));
					}}
					severity={snackbar?.severity}
					elevation={6}
					variant={snackbar?.variant ?? 'filled'}
				>
					{snackbar?.snackbarMessage}
				</Alert>
			)}
			{children}
		</>
	);
}
